import { trackCheckoutProgress } from '../../../../../../shared/analytics/e-commerce/trackCheckoutProgress';
import { trackViewItemList } from '../../../../../../shared/analytics/e-commerce/trackViewItemList';
import { IParkingProduct } from '../../../../../domain/parking-product/models/IParkingProduct';
import { adaptParkingProductToItem } from './adapters/adaptParkingProductToItem';
import { CheckoutSteps } from './CheckoutSteps';

export function trackViewParkingProducts(
	parkingProducts: IParkingProduct[],
	promoCode?: string,
	isPromoCodeValid?: boolean,
) {
	trackViewItemList({
		items: parkingProducts.map((parkingProduct) =>
			adaptParkingProductToItem(
				parkingProduct,
				isPromoCodeValid ? promoCode : undefined,
			),
		),
	});

	trackCheckoutProgress({
		step: CheckoutSteps.SelectProduct,
	});
}
